module.exports = __webpack_public_path__ + "static/media/gradient-bg-2.5d6deadf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/gradient-bg-2.jpg
// module id = 320
// module chunks = 0